export const DefaultPage = ({ tenantHeader }: { tenantHeader?: string }) => {
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="border border-[#eaeaea] rounded-lg p-12 flex flex-col items-center gap-4 max-w-[90%] sm:max-w-[400px]">
        <img src="/heala-logo-mark.svg" width={57} alt="Heala logo" />
        <h1 className="text-xl">{tenantHeader} Online consultation</h1>
        <p className="text-sm text-gray-500 text-center">
          Visit{" "}
          <a
            className="text-blue-950 underline leading-relaxed"
            href="https://developer.heala.io"
            target="_blank"
          >
            developer.heala.io
          </a>{" "}
          to integrate our consultation API or contact us if you need help with
          integration.
        </p>
      </div>
    </div>
  );
};
